import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import FriendIcon from '../../../Icons/Friend'
import Container from '../Container'

interface FriendButtonProps {
    shadow?: boolean
    title?: string
    color?: string
    size?: number
    filled?: boolean
    onClick?: any
    disabled?: boolean
}

const FriendButton = memo((props: FriendButtonProps) => {
    const {
        shadow = true,
        title,
        color,
        size,
        filled,
        onClick,
        disabled,
    } = props
    return (
        <Container shadow={shadow} title={title}>
            <IconButton onClick={onClick} disabled={disabled}>
                <FriendIcon
                    color={color ?? '#eee'}
                    filled={filled}
                    size={size}
                />
            </IconButton>
        </Container>
    )
})

export default FriendButton
